<template>
  <div class="language-switch">
    <div class="switch-container">
      <div
        class="switch-option"
        :class="{ active: currentLocale === 'zh' }"
        @click="handleCommand('zh')"
      >
        中
      </div>
      <div
        class="switch-option"
        :class="{ active: currentLocale === 'en' }"
        @click="handleCommand('en')"
      >
        En
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

const { locale } = useI18n();
const currentLocale = ref(locale.value);
const store = useStore();

const handleCommand = (command) => {
  currentLocale.value = command;
  locale.value = command;
  handleLanguageChange(command);
};

const handleLanguageChange = (lang) => {
  store.commit("setLang", lang);
};
</script>

<style lang="scss" scoped>
.language-switch {
  position: fixed;
  z-index: 1000;

  // 桌面端显示在右上角
  @media screen and (min-width: 768px) {
    top: 20px;
    right: 20px;
  }

  // 移动端显示在右下角悬浮球上方，更靠近右边
  @media screen and (max-width: 767px) {
    bottom: 80px;
    right: 12px; // 减小右侧距离
    padding-bottom: env(safe-area-inset-bottom, 5px);
  }
}

.switch-container {
  display: flex;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 24px;
  padding: 3px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);

  // 移动端改为垂直排列，宽度稍微调整
  @media screen and (max-width: 767px) {
    flex-direction: column;
    gap: 4px;
    width: 48px; // 调整为与扫码按钮相同的宽度
    padding: 4px; // 适当增加内边距
    margin-right: -6px; // 微调右侧位置以保持对齐
  }
}

.switch-option {
  padding: 6px 12px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  font-size: 14px;
  border-radius: 20px;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-align: center;
  line-height: 1.2;
  font-weight: 500;
  min-width: 32px;

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
  }

  &.active {
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  // 移动端样式调整
  @media screen and (max-width: 767px) {
    padding: 8px 4px;
    font-size: 14px;
    width: 40px; // 增加宽度
    height: 40px; // 增加高度，与扫码按钮保持一致
    border-radius: 20px;
    min-width: unset;
    display: flex;
    align-items: center;
    justify-content: center;

    &.active {
      width: 100%;
      margin: 0;
    }
  }
}

// 添加深色模式支持
@media (prefers-color-scheme: dark) {
  .switch-container {
    background: rgba(255, 255, 255, 0.1);
  }
}
</style>